import styled from 'styled-components';

export const Chat = styled.div`
  
  padding: 1.2rem;
  max-height: 100vh;

`;

export const Container = styled.div`
  background: ${(props) => props.theme.colors.darkBlue};
  height: 100%;
  border-radius: 1.2rem;
  padding: 1.6rem 2.4rem 2.4rem 2.4rem;
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const Username = styled.span`
  ${(props) => props.theme.fonts.interSemibold16};
  color: ${(props) => props.theme.colors.white100};
`;
